<template>
    <tr class="result-row live-game-row-tr" :live-id="game.live_id" :result-id="game.game_id"  teams="-"
        @click="openGameLink" :id="rowId" v-show="visibleRow">

            <td colspan="3" class="live-game-row-td rr-mobile">
                <div class="live-game-row">
                    <div @click.stop="toogleGameFav" class="fav-toggle">
                        <span :class="`text-green-700 fa-solid fa-${ game.favorite ? 'star' : 'star-empty text-muted'}`"></span>
                    </div>
                    <div class="live-game-status text-muted">
                        <div v-if="game.live_section">{{game.live_section}}</div>
                        <div v-if="game.period">{{game.period}}</div>
                    </div>
                    <div class="live-game-teams">
                        <div class="flex align-items-center mb-1">
                            <div :class="`team-img-s team-img-s-${game.league_id}`" :style="`--index:${game.t1-1};--ratio:1.75`"></div>
                            <span :class="calculateTeamClass(game, 1)">{{game.team_host}}</span>
                        </div>
                        <div class="flex align-items-center">
                            <div :class="`team-img-s team-img-s-${game.league_id}`" :style="`--index:${game.t2-1};--ratio:1.75`"></div>
                            <span :class="calculateTeamClass(game, 2)">{{game.team_guest}}</span>
                        </div>
                    </div>
                    <div class="live-game-icons">
                        <a href="" @click.stop="openGameEventsLink" v-if="game.ge_count > 0">
                            <span class="fa-solid fa-bullhorn"
                                data-bs-toggle="tooltip" :title="$parent.l.game_events_text_live"></span>
                        </a>
                    </div>
                    <div class="live-game-res justify-content-center">
                        <div :class="calculateClass(game, 1)" v-html="game.r1 || '&nbsp;'" v-if="game.r1 !== null"></div>
                        <div :class="calculateClass(game, 2)" v-html="game.r2 || '&nbsp;'" v-if="game.r2 !== null"></div>
                    </div>
                    <div class="live-game-notif" @click.stop="toggleGameNotification">
                        <i :class="getGameNotifIcon(game)"></i>
                    </div>
                </div>
            </td>
<!--        desktop-->
            <td class="date-time text-muted rr-desktop">
                <span class="game-date" :id="`live-${ game.game_id }-status`">{{game.live_status}}</span>
                <span class="game-time" :id="`live-${ game.game_id }-period`">{{game.period}}</span>
            </td>
            <td class="team-host rr-desktop">
                <div class="flex justify-content-end  align-items-center">
                    <span :class="calculateTeamClass(game, 1)">{{game.team_host}}</span>
                    <div :class="`team-img-s team-img-s-${game.league_id}`" :style="`--index:${game.t1-1};--ratio:1.75`"></div>
                </div>
            </td>
            <td class="live rr-desktop">
                <a :href="href" class="flex justify-content-center">
                    <div :class="calculateClass(game, 1)" v-html="game.r1 || '&nbsp;'" v-if="game.r1 !== null"></div>
                    <span class="res-dots">:</span>
                    <div :class="calculateClass(game, 2)" v-html="game.r2 || '&nbsp;'" v-if="game.r2 !== null"></div>
                </a>
            </td>
            <td class="team-guest rr-desktop">
                <div class="flex align-items-center">
                    <div :class="`team-img-s team-img-s-${game.league_id}`" :style="`--index:${game.t2-1};--ratio:1.75`"></div>
                    <span :class="calculateTeamClass(game, 2)">{{game.team_guest}}</span>
                </div>
            </td>
            <td class="rez_action rr-desktop">
              <div class="d-flex align-items-center gap-1 justify-content-end">
                <div v-if="game.editorid" class="p-1">
                  <span class="fa-solid fa-circle-info pointer hidden-xs"
                        data-bs-toggle="tooltip" :title="`${$parent.l.game_is_provided_by} ${game.signature}`"></span>
                </div>
                <div v-if="game.has_video" class="p-1">
                  <a href="" @click.prevent="openGameVideoLink" class="fa-solid fa-video pointer hidden-xs" style="left: revert; top: revert"
                     data-bs-toggle="tooltip" :title="`${$parent.l.game_video}`"></a>
                </div>
                <div v-if="game.ge_count > 0" class="p-1">
                  <a href="" @click.prevent="openGameEventsLink" style="left: revert; top: revert">
                      <span class="fa-solid fa-bullhorn pointer"
                            data-bs-toggle="tooltip" :title="$parent.l.game_events_text_live"></span>
                  </a>
                </div>
                <button :class="`btn btn-sm btn-${ game.favorite ? 'success' : 'outline-secondary'}`" type="button" @click.stop="toogleGameFav">
                  <span class="fa-solid fa-star"></span>
                </button>
                <button v-if="visibleNotificationBtn" :class="`ntf-btn btn btn-sm btn-${ game.notificationStatus ? 'success' : 'outline-secondary' } device-notif-button-multiple`"
                        type="button"
                        @click.stop="toggleGameNotification">
                  <span class="fa-solid fa-bell"></span>
                </button>
              </div>
            </td>
    </tr>
</template>
<script>
    import sf from "../modules/smartyfaces";
    import slugify from "slugify";

    export default {
        name: 'liveRow',
        props: ['game', 'mobile'],
        data() {
            return {
                loading: false,
            }
        },
        computed: {
            rowId() {
                return `live-${this.game.game_id}`;
            },
            visibleNotificationBtn() {
                return this.$parent.visibleNotificationBtn
            },
            visibleRow() {
                return !this.$parent.favorites || (this.$parent.favorites && this.game.favorite)
            },
            href() {
                let host = slugify(this.game.team_host,{lower:true, strict:true})
                let guest = slugify(this.game.team_guest,{lower:true, strict:true})
                return `/game/${this.game.game_id}-${host}-${guest}`
            }
        },
        methods: {
            openGameLink() {
                document.location.href=this.href;
            },
            openGameVideoLink(event) {
                event.stopPropagation()
                document.location.href=this.href + '/video#video';
            },
            openGameEventsLink(event) {
                event.stopPropagation()
                document.location.href=this.href + '#live_text'
            },
            toggleGameNotification() {
                this.loading = true
                this.game.notificationLoading = true
                this.$forceUpdate()
                VisitorNotification.toggle2(this.$parent.deviceId, 'game',this.game.game_id, (res)=>{
                    if(res) {
                        sf.ajax('VisitorNotificationAction::toggle2',{
                            device_id: this.$parent.deviceId,
                            token: this.$parent.deviceToken,
                            reference_type: 'game',
                            reference_id: this.game.game_id
                        }).then(res=>{
                            this.game.notificationStatus = res.data.result.status
                            this.game.count = res.data.result.count
                            this.game.notificationLoading = false
                            this.$forceUpdate()
                        })
                    }
                })
            },
            toogleGameFav() {
                this.game.favorite = !this.game.favorite
                this.$parent.storeFavorites(this.game)
            },
            calculateClass(game, t) {
                if(t === 1) {
                    return 'game-res game-res-1 ' + (game.r1 > game.r2 ? 'game-res-win' : game.r1 === game.r2 ? 'game-res-draw' : 'game-res-lose')
                } else {
                    return 'game-res game-res-2 ' + (game.r1 > game.r2 ? 'game-res-lose' : game.r1 === game.r2 ? 'game-res-draw' : 'game-res-win')
                }
            },
            calculateTeamClass(game, t) {
                if(t === 1) {
                    return 'game-team game-team-1 ' + (game.r1 > game.r2 ? 'team-win' : game.r1 === game.r2 ? 'team-draw' : 'team-lose')
                } else {
                    return 'game-team game-team-2 ' + (game.r1 > game.r2 ? 'team-lose' : game.r1 === game.r2 ? 'team-draw' : 'team-win')
                }
            },
            getGameNotifIcon(game) {
                return `text-green-700 fa ` + (game.notificationLoading ? 'fa-circle-notch fa-spin' : game.notificationStatus ? 'fa-bell' : 'fa-bell fa-regular')
            }
        }
    }
</script>
